import ModelTypeConstants from 'constants/ModelTypeConstants';
import MiniMapTabState from 'molbio/tabstates/MiniMapTabState';
import OligoLinearMapTabState from 'molbio/tabstates/OligoLinearMapTabState';
import RNASequenceLinearMapTabState from 'molbio/tabstates/RNASequenceLinearMapTabState';
import RNASequenceMiniMapTabState from 'molbio/tabstates/RNASequenceMiniMapTabState';
import SequenceLinearMapTabState from 'molbio/tabstates/SequenceLinearMapTabState';

export const SEQUENCE_LINEAR_MAP_TAB_STATES = {
  [ModelTypeConstants.SEQUENCE]: SequenceLinearMapTabState,
  [ModelTypeConstants.RNA_SEQUENCE]: RNASequenceLinearMapTabState,
  [ModelTypeConstants.DNA_OLIGO]: OligoLinearMapTabState,
  [ModelTypeConstants.RNA_OLIGO]: OligoLinearMapTabState,
} as const;

export const SEQUENCE_MINIMAP_TAB_STATES = {
  [ModelTypeConstants.SEQUENCE]: MiniMapTabState,
  [ModelTypeConstants.RNA_SEQUENCE]: RNASequenceMiniMapTabState,
} as const;
